export const AUTH_ROUTES = {
  SIGNUP_API_ENDPOINT: "/auth/signup",
  LOGIN_API_ENDPOINT: "/auth/login",
  GOOGLE_LOGIN_API_ENDPOINT: "/auth/google",
  USERS_API_ENDPOINT: "/users",
  ORDER_API_ENDPOINT: "/orders",
  PRODUCTS_API_ENDPOINT: "/products",
  ADMIN_PANEL_API_ENDPOINT: "/admin",
  BILLING_API_ENDPOINT: "/billing",
  REPORTS_API_ENDPOINT: "/reports",
  HOME_API_ENDPOINT: "/",
  OAUTH_CALLBACK_API_ENDPOINT: "/auth/callback",
  CUSTOMER_REPORT_API_ENDPOINT :"/reports/customer",
  DAILY_REPORT_API_ENDPOINT: "/reports/daily",
  MONTHLY_REPORT_API_ENDPOINT: "/reports/monthly",
  YEARLY_REPORT_API_ENDPOINT: "/reports/yearly",
  RANGE_REPORT_BY_QUERY_API_ENDPOINT: "/reports/range",
  OAUTH_CALLBACK: "/auth/redirect",

  CATEGORIES_API_ENDPOINT: "/categories",
};
